export default "__VITE_ASSET__BuhumNlo__"